import { Box, Container, Grid, Paper, Typography, useMediaQuery } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../../lib/ui/theme';
import type { SearchLayoutProps } from '../../types/components/SearchLayoutProps';

export const SearchLayout: FC<SearchLayoutProps> = (props: SearchLayoutProps) => {
    const { t } = useTranslation();
    const { children } = props;
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    return (
        <>
            <Container maxWidth="xl">
                <Paper elevation={3} sx={{ paddingBottom: 3 }}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Box sx={{ backgroundColor: '#003C60', height: 58, borderRadius: '5px 5px 0px 0px' }} display={'flex'} alignItems={'center'} px={3}>
                                <Typography variant="h2" color="white">
                                    {t('transportTicketSelect')}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box p={matches ? 3 : 1.5}>{children}</Box>
                </Paper>
            </Container>
        </>
    );
};
